import { createSlice } from "@reduxjs/toolkit";

let nextId = 1;

const initialState = {
  hiddenElements: [],
  pickerActive: false,
  targetUrl: '',
  previewMode: false,
  loading: false,
  error: null,
};

const elementHiderSlice = createSlice({
  name: "elementHider",
  initialState,
  reducers: {
    addElement(state, action) {
      const { selector, elementTag = '', elementClasses = '', textSnippet = '' } = action.payload;
      state.hiddenElements.push({
        id: nextId++,
        selector,
        elementTag,
        elementClasses,
        textSnippet,
        isHidden: true,
        matchCount: 0,
      });
    },
    removeElement(state, action) {
      state.hiddenElements = state.hiddenElements.filter(
        (el) => el.id !== action.payload
      );
    },
    toggleElement(state, action) {
      const el = state.hiddenElements.find((e) => e.id === action.payload);
      if (el) {
        el.isHidden = !el.isHidden;
      }
    },
    updateSelector(state, action) {
      const { id, selector } = action.payload;
      const el = state.hiddenElements.find((e) => e.id === id);
      if (el) {
        el.selector = selector;
      }
    },
    updateMatchCount(state, action) {
      const { id, matchCount } = action.payload;
      const el = state.hiddenElements.find((e) => e.id === id);
      if (el) {
        el.matchCount = matchCount;
      }
    },
    reorderElements(state, action) {
      state.hiddenElements = action.payload;
    },
    setPickerActive(state, action) {
      state.pickerActive = action.payload;
    },
    setTargetUrl(state, action) {
      state.targetUrl = action.payload;
    },
    togglePreviewMode(state) {
      state.previewMode = !state.previewMode;
    },
    clearAllElements(state) {
      state.hiddenElements = [];
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
  },
});

export const {
  addElement,
  removeElement,
  toggleElement,
  updateSelector,
  updateMatchCount,
  reorderElements,
  setPickerActive,
  setTargetUrl,
  togglePreviewMode,
  clearAllElements,
  setLoading,
  setError,
} = elementHiderSlice.actions;

export default elementHiderSlice.reducer;
